import React from "react";

import { CustomerPortalProvider } from "Context/CustomerPortalContext";
import { Route, Switch } from "react-router-dom";

import { CustomerPortalBackGround } from "./CustomerPortalBackground";
import { CustomerPortalFooter } from "./CustomerPortalFooter";
import { CustomerPortalHeader } from "./CustomerPortalHeader";
import { OrderPage } from "./OrderPage";
import { CustomerPortalRedirectToDetails } from "./RedirectPage";
import { PageWrapper, PageMain, PageMainContent } from "./styles";

const CustomerPortalPage = () => {
  return (
    <PageWrapper>
      <CustomerPortalHeader />

      <CustomerPortalBackGround />

      <PageMain>
        <CustomerPortalBackGround />

        <PageMainContent>
          <Switch>
            <Route component={CustomerPortalRedirectToDetails} path="/" exact />
            <Route component={CustomerPortalRedirectToDetails} path="/:jobIdToken" exact />
            <Route component={OrderPage} path="/jobs/:jobIdToken" exact />
          </Switch>
        </PageMainContent>
      </PageMain>

      <CustomerPortalFooter />
    </PageWrapper>
  );
};

export const CustomerPortal = () => {
  return (
    <CustomerPortalProvider>
      <CustomerPortalPage />
    </CustomerPortalProvider>
  );
};
